import { Select } from '@airasia/phoenix-components/components/Select';
import { action, observable, makeObservable } from 'mobx';
import { Log } from '@/helper/log';
import { CommonApi, DemoApi } from '@/api';
import { webStore } from '@/store/base';
import { StoreUtil } from '@/store/common';
import AStore from './a';
import BStore from './b';
import { json } from 'stream/consumers';

export default class DemoStore implements PageStore {
  private CLASS_NAME = 'DemoStore';
  aStore: AStore = new AStore();
  bStore: BStore = new BStore();

  @observable testName = '';
  @observable apiKey = '';
  @observable xcsTraceId = '';
  @observable selectedBaggage = null;
  @observable baggageData = [];
  @observable isShow = false;

  constructor() {
    makeObservable(this);
  }

  getName = () => {};

  parseSearchParams = async () => {
    const data = await StoreUtil.parseSearchParams();
    console.info('...Demo parseSearchParams: data received...', data);
  };

  @action
  async onLoad() {
    await this.parseSearchParams();

    console.info('...in DemoStore onLoad....');
  }

  @action
  searchFlight = async () => {
    // const result = await DemoApi.testZodiacSearch();
    // this.xcsTraceId = result.xcsTraceId;
  };

  @action
  onUnload = () => {};

  get selectBaggage() {
    console.info('...selectBaggage this...', this);
    console.info('...selectBaggage this...', this.selectedBaggage);
    return JSON.parse(JSON.stringify(this.selectedBaggage));
  }

  get aStoreData() {
    return this.aStore.someData;
  }

  @action
  handleBaggage = (data) => {
    console.info('....handleBaggage data...', JSON.stringify(data));
    this.selectedBaggage = data;
  };
}
